import { Component, Input } from '@angular/core';
import { Fields } from '@constants/constant';
import { CommonModule } from '@angular/common';
import { CurrencyToLocal } from '@shared/pipes/convertCurrencyToLocal.pipe';

@Component({
  selector: 'app-price-display',
  template: `
    <ng-container *ngIf="showExchange; else dollarCurrency">
      <ng-container *ngIf="showDollarOut; else showDollarIn">
        {{ price | currency }}
        <span
          *ngIf="!showOnlyCurrency"
          class="currency-exchange-label"
          [style.fontSize]="dollarFontSize"
        >
          ({{ localPrice ? (localPrice | currency : symbol) : (price | currencyToLocal: rate : symbol) }})
        </span>
      </ng-container>
      <ng-template #showDollarIn>
        {{ localPrice ? (localPrice | currency : symbol) : (price | currencyToLocal: rate : symbol) }}
        <span
          *ngIf="!showOnlyCurrency"
          class="currency-exchange-label"
          [style.fontSize]="dollarFontSize"
        >
          ({{ price | currency }})
        </span>
      </ng-template>
    </ng-container>

    <ng-template #dollarCurrency>
      {{ price | currency }}
    </ng-template>
  `,
  standalone: true,
  imports: [CommonModule, CurrencyToLocal]
})
export class PriceDisplayComponent {
  @Input() price!: number;
  @Input() rate!: number | null | undefined;
  @Input() symbol!: string;
  @Input() dollarFontSize: string = '12px';
  @Input() showOnlyCurrency: boolean = false;
  @Input() showDollarOut: boolean = false;
  @Input() localPrice: number | string = 0;
  @Input() dollarPrice: number | string = 0;

  Fields: typeof Fields = Fields;

  get showExchange(): boolean {
    return !!(this.rate && this.symbol && Fields.DOLLAR_SYMBOL !== this.symbol);
  }
}
